import { Navigate } from "react-router-dom";
import { JSX } from "react";
import { useUserContext } from "../contexts/userContext";
import LoadingSpinner from "../components/ui/LoadingSpinner";

interface PublicRouteProps {
  children: JSX.Element;
  redirectTo?: string; // Page vers laquelle rediriger si déjà connecté
}

const PublicRoute = ({ children, redirectTo }: PublicRouteProps) => {
  const { isLoading, isAuthenticated, typeRole } = useUserContext();


  // Si on est en train de charger, afficher le spinner
  if (isLoading) {
    return <LoadingSpinner size="large" text="Vérification de l'authentification..." />;
  }

  // Si l'utilisateur est déjà authentifié, le rediriger
  if (isAuthenticated) {
    const targetPath = redirectTo || (typeRole === "Customer" ? "/customer-area/dashboard" : "/dashboard");
    return <Navigate to={targetPath} replace />;
  }

  // Si pas authentifié, afficher la page publique (login, etc.)
  return children;
};

export default PublicRoute;
